import styled from 'styled-components/macro'
import { FaChevronDown, FaChevronRight } from 'react-icons/fa'
import { useDataTableContext } from 'components/DataTable'
import { useDataTableRowContext } from 'components/DataTable/DataTable/DataTableRow/DataTableRowContext'

const Container = styled.div`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667085;
`

function RowExpandArrow<T extends object>() {
  const {
    state: { expanded },
  } = useDataTableContext<T>()
  const { row, expandCell } = useDataTableRowContext<T>()

  const isExpanded = expandCell ? expanded.includes(expandCell.id) : false

  return (
    <>
      {(row?.getCanExpand() || expandCell) && (
        <Container>
          {row?.getIsExpanded() || isExpanded ? (
            <FaChevronDown size={14} />
          ) : (
            <FaChevronRight size={14} />
          )}
        </Container>
      )}
    </>
  )
}

export default RowExpandArrow
